/*
 * Clare custom purchase options.
 *
 * Replaces the Skio app-block UI. Skio still powers the subscriptions
 * themselves — this only drives which selling plan and quantity the theme's
 * product form submits.
 *
 * The option cards and the one-time link render as two separate theme blocks
 * (they sit either side of the add-to-cart button), but their radios share a
 * name so the browser treats them as one group. Neither block sits inside the
 * product form, so the chosen values are mirrored into hidden inputs on it.
 */
(function () {
  if (window.__clarePurchaseOptions) return;
  window.__clarePurchaseOptions = true;

  var ROOT_SELECTOR = "[data-purchase-options], [data-purchase-onetime]";

  function groupName(sectionId) {
    return 'purchase-option-' + sectionId;
  }

  function findForm(sectionId) {
    var host = document.querySelector(
      'product-form-component[data-section-id="' + sectionId + '"]'
    );
    if (!host) return null;
    return host.querySelector('form[data-type="add-to-cart-form"]') || host.querySelector("form");
  }

  /* Reuses an input the theme already renders (e.g. the quantity selector, if
     it is ever re-enabled) rather than adding a duplicate of the same name. */
  function setField(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.setAttribute("data-purchase-options-input", "");
      form.appendChild(input);
    }
    input.value = value;
    return input;
  }

  function apply(sectionId) {
    var form = findForm(sectionId);
    if (!form) return;

    var checked = document.querySelector(
      'input[name="' + groupName(sectionId) + '"]:checked'
    );
    if (!checked) return;

    var planId = checked.dataset.sellingPlan || "";
    var quantity = checked.dataset.quantity || "1";
    var variantId = checked.dataset.variantId || "";

    var planInput = setField(form, "selling_plan", planId);
    /* A disabled input is dropped from FormData, which is how a one-time
       purchase is expressed. Submitting selling_plan="" is not equivalent. */
    planInput.disabled = planId === "";

    setField(form, "quantity", quantity);

    if (variantId) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;
    }

    /* The one-time button is deliberately left alone. It used to track the
       selected plan's volume (3-month made it "Buy Once for $297"), but that
       turned a simple fallback into a third, expensive-looking option. It now
       stays at the single bag its own block renders, whatever is selected
       above. To restore the old behaviour, mirror checked.dataset.onetimePrice
       into [data-purchase-onetime-price] and the quantity onto the button. */

    form.dispatchEvent(
      new CustomEvent("purchase-options:change", {
        bubbles: true,
        detail: { sellingPlan: planId, quantity: quantity, variantId: variantId },
      })
    );
  }

  /* "Buy once" adds straight to cart instead of selecting an option, so the
     shopper's subscription choice is left untouched and the cards never go
     blank. The theme's own add-to-cart button is clicked rather than the form
     submitted directly, so the cart drawer, loading state and error handling
     are identical to a normal add. */
  function buyOnce(sectionId, quantity) {
    var form = findForm(sectionId);
    if (!form) return;

    var submitter =
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]');
    if (!submitter) return;
    if (submitter.disabled || submitter.getAttribute("disabled") === "true") return;

    var planInput = setField(form, "selling_plan", "");
    planInput.disabled = true;
    setField(form, "quantity", quantity || "1");

    submitter.click();

    /* handleSubmit builds its FormData synchronously, so by the time click()
       returns the one-time values are already captured and the form can be put
       back to whichever subscription option is still selected. */
    apply(sectionId);
  }

  function init() {
    var sections = {};
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (el) {
      if (el.dataset.sectionId) sections[el.dataset.sectionId] = true;
    });

    Object.keys(sections).forEach(function (sectionId) {
      var radios = document.querySelectorAll(
        'input[name="' + groupName(sectionId) + '"]'
      );

      radios.forEach(function (input) {
        if (input.dataset.poBound) return;
        input.dataset.poBound = "true";
        input.addEventListener("change", function () {
          apply(sectionId);
        });
      });

      /* The template marks the preferred option as checked, but that option
         only renders if its selling plan is still attached in Skio. If it is
         not, fall back to the first option that did render — otherwise nothing
         is selected and the form silently submits a one-time purchase. */
      if (radios.length && !document.querySelector(
        'input[name="' + groupName(sectionId) + '"]:checked'
      )) {
        radios[0].checked = true;
      }

      document
        .querySelectorAll(
          '[data-purchase-onetime][data-section-id="' + sectionId + '"] [data-purchase-onetime-button]'
        )
        .forEach(function (btn) {
          if (btn.dataset.poBound) return;
          btn.dataset.poBound = "true";
          btn.addEventListener("click", function () {
            buyOnce(sectionId, btn.dataset.quantity);
          });
        });

      /* Sync the form with whichever option is checked on first paint, so the
         default selection is honoured even if the shopper never touches it. */
      apply(sectionId);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
